import { useRef, useEffect } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useInView } from "framer-motion";
import { formatNumber } from "../../lib/utils"; // Make sure to import your formatNumber utility

interface AnimatedCounterProps {
  value: number;
  label: string;
  isMobile?: boolean;
}

export const AnimatedCounter = ({
  value,
  label,
  isMobile = false,
}: AnimatedCounterProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref);
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => formatNumber(latest));

  useEffect(() => {
    if (isInView) {
      animate(count, value, {
        duration: 2,
        ease: "easeOut",
      });
    }
  }, [isInView, value, count]);

  if (isMobile) {
    return (
      <div
        ref={ref}
        className="flex flex-col bg-white shadow-sm rounded-2xl p-2 "
      >
        <motion.h1
          className="text-2xl xs:text-[5vw] text-center font-helveticaBold"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 0 }}
        >
          <motion.span
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            +<motion.span>{rounded}</motion.span>
          </motion.span>
        </motion.h1>
        <p className="font-helvetica text-base xs:text-[3vw] text-center text-gray-600">
          {label}
        </p>
      </div>
    );
  }

  return (
    <div
      ref={ref}
      className="bg-white flex justify-center items-center flex-col p-6 shadow-sm rounded-xl"
    >
      <motion.p
        className="text-[1.7vw] font-helveticaBold"
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : { opacity: 0 }}
      >
        <motion.span
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          +<motion.span>{rounded}</motion.span>
        </motion.span>
      </motion.p>
      <p className="text-[1vw] text-center text-nowrap">{label}</p>
    </div>
  );
};
